var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 62,
    viewBox: "0 0 58 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7609 44.6438C15.9646 43.2655 12.4703 40.4477 12.6296 35.1968C12.7354 33.1571 13.2365 31.1572 14.1048 29.3085L14.2528 28.9687C17.0098 23.0416 27.1533 14.1169 35.6301 7.85188C36.4258 7.26123 37.2051 6.6973 37.968 6.16012C37.968 6.16012 38.0212 6.1221 38.0475 6.10075C41.9944 3.3143 45.3272 1.29378 46.9981 0.713142C50.3565 -0.4733 51.5523 1.00337 51.9728 2.2733C52.1909 2.94681 52.2348 3.66456 52.1006 4.35964C51.4037 8.19958 50.3623 11.9689 48.9889 15.622C48.9761 15.6644 48.9594 15.7055 48.9389 15.7448C44.2436 28.2223 36.729 37.5169 33.2285 42.5633C33.1278 42.7002 33.0322 42.8414 32.9451 42.9724L32.895 43.0432C28.5042 49.3396 20.158 46.4861 17.7609 44.6438Z",
    fill: "url(#paint0_linear_217_9501)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M32.8807 43.0437L33.6341 39.4058C40.0347 32.44 45.2034 24.436 48.9189 15.7363C44.2433 28.2215 36.7286 37.5161 33.2282 42.5625C33.1275 42.6994 33.0319 42.8406 32.9448 42.9716L32.8807 43.0437Z",
    fill: "#43675E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M12.6113 35.2034C12.7172 33.1636 13.2182 31.1638 14.0866 29.315L14.2346 28.9752C16.9916 23.0481 27.135 14.1235 35.6118 7.8584C35.017 8.42407 16.0192 26.7206 13.6712 33.2854C13.4311 33.9811 13.0726 34.6299 12.6113 35.2034Z",
    fill: "#43675E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7607 44.6435C15.3837 42.8135 10.0225 38.468 14.0863 29.3146C17.395 26.5261 23.1141 26.6891 27.8188 29.9709C32.5235 33.2527 34.6373 38.5049 33.2142 42.5643C33.1135 42.7012 33.0179 42.8424 32.9309 42.9734C28.5675 49.3617 20.168 46.4943 17.7607 44.6435Z",
    fill: "#354E4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1697 43.8158C22.6702 46.9529 28.2846 46.6756 30.7098 43.1963C33.1351 39.7171 31.4529 34.3535 26.9524 31.2164C22.452 28.0793 16.8376 28.3566 14.4124 31.8359C11.9871 35.3151 13.6693 40.6787 18.1697 43.8158Z",
    fill: "#1B232A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7116 24.772C8.9291 24.4683 17.7137 12.4659 26.1751 18.5411L20.7725 24.6291L19.6045 25.9427C19.6045 25.9427 15.4544 22.4251 8.7116 24.772Z",
    fill: "#6EC5A2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8287 47.674C38.6246 40.5776 34.2752 37.3054 34.2752 37.3054L35.2573 35.924L40.0249 29.257C47.8306 36.1587 38.0723 47.3962 37.8283 47.6693L37.8287 47.674Z",
    fill: "#6EC5A2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7123 18.0768C33.9605 20.7472 36.3265 22.7107 38.9969 22.4625C41.6673 22.2143 43.6308 19.8483 43.3826 17.1779C43.1343 14.5075 40.7683 12.544 38.098 12.7922C35.4276 13.0405 33.4641 15.4065 33.7123 18.0768Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1315 17.945C35.3068 19.8314 36.9782 21.2184 38.8645 21.0431C40.7508 20.8677 42.1379 19.1964 41.9625 17.31C41.7872 15.4237 40.1158 14.0367 38.2295 14.212C36.3432 14.3874 34.9561 16.0587 35.1315 17.945Z",
    fill: "#1B232A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M48.919 15.7363C46.8296 8.51118 41.7927 6.5362 37.9621 6.15035C37.9621 6.15035 38.0153 6.11234 38.0417 6.09098C41.9885 3.30454 45.3213 1.28401 46.9922 0.703376C50.3506 -0.483065 51.5464 0.993608 51.9669 2.26354C52.185 2.93704 52.229 3.65479 52.0947 4.34987C51.3978 8.18982 50.3564 11.9592 48.983 15.6122L48.919 15.7363Z",
    fill: "#6EC5A2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6493 46.59C26.7653 44.9212 27.1946 42.8863 26.8479 40.9089C26.5012 38.9315 25.4051 37.1641 23.7878 35.9746C22.1706 34.7852 20.1569 34.2653 18.166 34.5234C16.1751 34.7815 14.3604 35.7975 13.0999 37.36C13.0999 37.36 6.99795 43.9572 5.23684 61.1571C5.23684 61.1571 12.816 59.7248 24.2818 48.045C24.7973 47.6198 25.2568 47.1309 25.6493 46.59Z",
    fill: "url(#paint1_linear_217_9501)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7448 43.7423C24.1032 43.2582 24.3627 42.7082 24.5085 42.1237C24.6543 41.5392 24.6836 40.9318 24.5947 40.336C24.5057 39.7402 24.3003 39.1678 23.9901 38.6514C23.6799 38.1351 23.2711 37.6848 22.7869 37.3265C22.3028 36.9681 21.7527 36.7086 21.1683 36.5628C20.5838 36.417 19.9764 36.3877 19.3806 36.4766C18.7848 36.5656 18.2124 36.771 17.696 37.0812C17.1797 37.3914 16.7294 37.8002 16.371 38.2844C16.371 38.2844 12.7855 42.162 11.7538 52.2622C11.7538 52.2622 16.2031 51.4233 22.9371 44.5594C23.2394 44.3218 23.5107 44.0473 23.7448 43.7423Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71129 24.772C8.89805 24.646 14.5206 20.924 20.7722 24.6291L19.6042 25.9427C19.6042 25.9427 15.4541 22.4251 8.71129 24.772Z",
    fill: "url(#paint2_linear_217_9501)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8285 47.6733C38.6244 40.5769 34.275 37.3047 34.275 37.3047L35.2571 35.9232C35.2571 35.9232 39.8612 41.0716 37.8328 47.6682L37.8285 47.6733Z",
    fill: "url(#paint3_linear_217_9501)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_217_9501",
    x1: -5185.59,
    y1: 14897.9,
    x2: -8676.2,
    y2: 18831.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#99D0B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#5F9D84"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_217_9501",
    x1: 23.9492,
    y1: 35.5197,
    x2: 7.80245,
    y2: 58.1021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EE7671"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B232A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_217_9501",
    x1: -1989.07,
    y1: 1249.71,
    x2: -2096.94,
    y2: 1809.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45695E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1B232A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_217_9501",
    x1: -45.5567,
    y1: 4182.31,
    x2: -573.367,
    y2: 4386.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45695E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#1B232A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.fcd583b6d5dc07709da38f3db01e64f8.svg";
export { ForwardRef as ReactComponent };